export default "__VITE_ASSET__DiELieoC__"